<template>
	<input
		ref="inputRef"
		:id="id"
		:value="value"
		:placeholder="placeholder"
		type="text"
		@focus="geolocate"
	/>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
export default {
	name: 'LocationPickerAutocomplete',
	props: {
		value: {
			type: String,
		},
		placeholder: {
			type: String,
			default: 'Search location...'
		},
		id: {
			type: String,
			default: () => {
				return Math.random().toString(36).slice(-10)
			}
		},
		enableGeolocation: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		autocomplete: null,
		geolocateSet: false,
		autocompleteText: '',
	}),
	mounted() {
		if (this.google && this.$refs.inputRef) {
			this.setupGoogle()
		}
	},
	computed: {
		google: gmapApi
	},
	watch: {
		google: {
			deep: true,
			immediate: true,
			handler(v) {
				if (v) this.setupGoogle()
			}
		},
		enableGeolocation(newVal) {
			if (!newVal) this.geolocateSet = false
			this.enableGeolocation = newVal
		},
	},
	methods: {
		onChange() {
			this.$emit('change', this.autocompleteText);
		},
		geolocate() {
			if (this.enableGeolocation && !this.geolocateSet) {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition((position) => {
						const geolocation = {
							lat: position.coords.latitude,
							lng: position.coords.longitude,
						};
						const circle = new this.google.maps.Circle({
							center: geolocation,
							radius: position.coords.accuracy,
						});
						this.autocomplete.setBounds(circle.getBounds());
						this.geolocateSet = true;
					});
				}
			}
		},
		setupGoogle() {
			if (!this.$refs.inputRef) return

			this.autocomplete = new this.google.maps.places.Autocomplete(
				this.$refs.inputRef, {}
			);
			this.autocomplete.addListener('place_changed', () => {
				const place = this.autocomplete.getPlace();

				if (!place.geometry) {
					return this.$emit('no-results-found', place);
				}

				const addressComponents = {
					street_number: 'short_name',
					route: 'long_name',
					locality: 'long_name',
					administrative_area_level_1: 'short_name',
					country: 'long_name',
					postal_code: 'short_name',
				};

				const returnData = {};

				if (place.address_components !== undefined) {
					for (let i = 0; i < place.address_components.length; i += 1) {
						const addressType = place.address_components[i].types[0];

						if (addressComponents[addressType]) {
							const val = place.address_components[i][addressComponents[addressType]];
							returnData[addressType] = val;
						}
					}

					returnData.latitude = place.geometry.location.lat();
					returnData.longitude = place.geometry.location.lng();

					this.autocompleteText = this.$refs.inputRef.value;
					if (!returnData.name) returnData.name = this.autocompleteText

					this.$emit('placechanged', returnData, place, this.id);
					this.onChange();
				}
			});
		},
	}
}
</script>
<style scoped lang='scss'>
	input {
		display: block;
		width: 100%;
		height: calc(1.5em + 1.25rem + 2px);
		padding: 0.625rem 0.75rem;
		font-size: 0.875rem;
		font-weight: 400;
		line-height: 1.5;
		color: #8898aa;
		background-color: #fff;
		background-clip: padding-box;
		border: 1px solid #cad1d7;
		border-radius: 0.375rem;
		-webkit-box-shadow: none;
		box-shadow: none;
		-webkit-transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
		transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
	}
</style>